import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Button } from 'primeng/button';

import { StaleBuildService } from '../../services/stale-build.service';

/**
 * A strip across the top of the content column, shown once the running build
 * has been found to be older than the deployed one. Stays until the page is
 * reloaded: dismissing it would only postpone the next broken click.
 *
 * `role="alert"` announces it the moment it appears — the failure the person
 * just saw (a screen that did not open) has no explanation of its own.
 */
@Component({
  selector: 'app-stale-build-banner',
  imports: [Button, TranslatePipe],
  template: `
    @if (staleBuild.detected()) {
      <div class="stale-build" role="alert">
        <i class="pi pi-refresh stale-build__icon" aria-hidden="true"></i>
        <div class="stale-build__text">
          <strong>{{ 'staleBuild.title' | translate }}</strong>
          <span>{{ 'staleBuild.body' | translate }}</span>
        </div>
        <p-button
          size="small"
          severity="warn"
          icon="pi pi-refresh"
          [label]="'staleBuild.reload' | translate"
          (onClick)="staleBuild.reload()"
        />
      </div>
    }
  `,
  styles: `
    .stale-build {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      flex-shrink: 0;
      padding: 0.5rem 1.25rem;
      border-block-end: 1px solid var(--sw-warning);
      background: var(--sw-warning-bg);
      color: var(--sw-ink);
      font-family: var(--sw-font-sans);
      font-size: 13px;
    }

    .stale-build__icon {
      color: var(--sw-warning);
    }

    .stale-build__text {
      display: flex;
      flex: 1;
      min-width: 0;
      flex-wrap: wrap;
      column-gap: 0.5rem;
    }
  `,
})
export class StaleBuildBanner {
  protected readonly staleBuild = inject(StaleBuildService);
}
